import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/auth/signin/page.tsx");
